import { render, staticRenderFns } from "./VerifyOrderItems.vue?vue&type=template&id=49cad84c&scoped=true&"
import script from "./VerifyOrderItems.vue?vue&type=script&lang=js&"
export * from "./VerifyOrderItems.vue?vue&type=script&lang=js&"
import style0 from "./VerifyOrderItems.vue?vue&type=style&index=0&id=49cad84c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cad84c",
  null
  
)

export default component.exports